import React from "react";
import { Sparkles, Loader2 } from "lucide-react";
import { fmtD } from "../../lib/date";

/* 标准工期学习建议：每格下方的建议芯片 */
export function SuggestBadge({ s, zh, canEdit, current, testid, onAdopt }) {
  if (!s) return null;
  if (!s.count) return <span className="block text-[9px] text-slate-300 mt-0.5" data-testid={`${testid}-none`}>—</span>;
  if (s.suggested == null) return <span className="block text-[9px] text-slate-400 mt-0.5" data-testid={`${testid}-few`} title={zh ? `实际中位 ${s.median} 天，样本不足` : `median ${s.median}d, too few samples`}>{zh ? `样本 ${s.count}/3` : `n=${s.count}/3`}</span>;
  const same = s.suggested === current;
  const tip = zh ? `近期实际：中位 ${s.median} · P75 ${s.p75} · 均值 ${s.avg} · ${s.count} 个样本（${s.min}–${s.max} 天）` : `median ${s.median} · P75 ${s.p75} · avg ${s.avg} · n=${s.count} (${s.min}–${s.max}d)`;
  return (
    <button type="button" disabled={!canEdit || same} onClick={onAdopt} data-testid={testid} title={tip}
      className={`block mx-auto mt-0.5 text-[9px] leading-tight rounded px-1 py-px border ${same ? "text-emerald-700 bg-emerald-50 border-emerald-200" : s.suggested > current ? "text-amber-700 bg-amber-50 border-amber-200 hover:bg-amber-100" : "text-sky-700 bg-sky-50 border-sky-200 hover:bg-sky-100"} disabled:cursor-default`}>
      {same ? (zh ? "已一致" : "matches") : (zh ? `建议 ${s.suggested}` : `→ ${s.suggested}`)}<span className="text-slate-400"> · n{s.count}</span>
    </button>
  );
}

export function SuggestBar({ sug, loading, months, setMonths, zh, canEdit, onAdoptAll, adoptable }) {
  return (
    <div className="bg-white rounded-xl border border-sky-200 px-4 py-3 flex flex-wrap items-center gap-3" data-testid="ps-suggest-bar">
      <Sparkles className="h-4 w-4 text-sky-600" />
      <div className="text-xs text-slate-700 flex-1 min-w-[240px]" data-testid="ps-suggest-summary">
        {loading || !sug ? <span className="text-slate-400"><Loader2 className="h-3 w-3 animate-spin inline mr-1" />{zh ? "统计实际阶段耗时…" : "Analysing actual phase durations…"}</span> : (
          <>
            <b>{zh ? `近 ${sug.months} 个月实际阶段耗时` : `Actual phase durations, last ${sug.months} months`}</b>
            <span className="text-slate-500"> · {zh ? `样本项目 ${sug.sampleProjects} 个` : `${sug.sampleProjects} projects`} · {zh ? "建议值 = 中位数，样本 ≥ 3 才给" : "suggestion = median, needs ≥3 samples"}
              {sug.recordedSince ? ` · ${zh ? "推进记录自" : "recorded since"} ${fmtD(sug.recordedSince)}` : ` · ${zh ? "系统从本次上线起记录每次「完成本阶段」的日期，样本将逐月累积" : "phase transitions are recorded from now on; samples accrue monthly"}`}</span>
          </>
        )}
      </div>
      <select value={months} onChange={(e) => setMonths(Number(e.target.value))} data-testid="ps-suggest-months" className="h-8 rounded-md border border-input bg-background px-2 text-xs">
        {[3, 6, 12].map((m) => <option key={m} value={m}>{zh ? `近 ${m} 个月` : `${m} months`}</option>)}
      </select>
      {canEdit && <button onClick={onAdoptAll} disabled={!adoptable} data-testid="ps-adopt-all" className="inline-flex items-center gap-1 text-xs font-semibold text-white bg-sky-600 hover:bg-sky-700 rounded-full px-3 py-1.5 disabled:opacity-40">{zh ? `一键采纳全部建议（${adoptable}）` : `Adopt all (${adoptable})`}</button>}
    </div>
  );
}
